export default {
  PLACE: 'place',
  CANONICAL: 'canonical',
};
